// import React, { useEffect, useState, useRef } from "react";
// import { Modal, Button, Form, Table } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FaPlus, FaEye, FaEdit } from "react-icons/fa";
// import { RiDeleteBin3Fill } from "react-icons/ri";
// import { BsThreeDots } from "react-icons/bs";
// import { MdAirplanemodeInactive, MdAirplanemodeActive } from "react-icons/md";

// const API_URL = process.env.REACT_APP_API_URL;
// const imageAPIURL = process.env.REACT_APP_Image_URL;

// function ManualPaymentList() {
//   const [payments, setPayments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [selectedPayment, setSelectedPayment] = useState(null);
//   const [saving, setSaving] = useState(false);

//   const [formData, setFormData] = useState({
//     upi_id: "",
//     account_holder_name: "",
//     account_number: "",
//     ifsc_code: "",
//     bank_name: "",
//     branch_name: "",
//     status: "active",
//     qr_code: null,
//   });

//   const [editFormData, setEditFormData] = useState({
//     id: "",
//     upi_id: "",
//     account_holder_name: "",
//     account_number: "",
//     ifsc_code: "",
//     bank_name: "",
//     branch_name: "",
//     status: "active",
//     qr_code: null,
//   });

//   const [showMessageModal, setShowMessageModal] = useState(false);
//   const [messageModalContent, setMessageModalContent] = useState({
//     title: "",
//     text: "",
//     type: "",
//     confirmAction: null,
//   });

//   const getAuthToken = () => localStorage.getItem("token");

//   const showCustomMessageModal = (title, text, type, confirmAction = null) => {
//     setMessageModalContent({ title, text, type, confirmAction });
//     setShowMessageModal(true);
//   };

//   const closeCustomMessageModal = () => {
//     setShowMessageModal(false);
//     setMessageModalContent({
//       title: "",
//       text: "",
//       type: "",
//       confirmAction: null,
//     });
//   };

//   const fetchPayments = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error"
//         );
//         return;
//       }
//       const response = await fetch(`${API_URL}/manual-payment-list`, {
//         method: "GET",
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       const data = await response.json();
//       if (!response.ok) {
//         showCustomMessageModal(
//           "Error",
//           data.message || "Failed to fetch manual payment details.",
//           "error"
//         );
//         return;
//       }
//       if (data.success === "1") {
//         setPayments(data.data || []);
//       } else {
//         showCustomMessageModal(
//           "Error",
//           data.message || "Failed to fetch manual payment details.",
//           "error"
//         );
//       }
//     } catch (err) {
//       console.error("Fetch Manual Payment Error:", err);
//       setError(err.message);
//       showCustomMessageModal(
//         "Error",
//         err.message || "Something went wrong while fetching payment details.",
//         "error"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPayments();
//   }, []);

//   const resetAddForm = () => {
//     setFormData({
//       upi_id: "",
//       account_holder_name: "",
//       account_number: "",
//       ifsc_code: "",
//       bank_name: "",
//       branch_name: "",
//       status: "active",
//       qr_code: null,
//     });
//   };

//   const handleFormChange = (e) => {
//     const { name, value, files } = e.target;
//     if (name === "qr_code") {
//       setFormData((prev) => ({
//         ...prev,
//         qr_code: files && files[0] ? files[0] : null,
//       }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   const handleEditFormChange = (e) => {
//     const { name, value, files } = e.target;
//     if (name === "qr_code") {
//       setEditFormData((prev) => ({
//         ...prev,
//         qr_code: files && files[0] ? files[0] : null,
//       }));
//     } else {
//       setEditFormData((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   const handleCreatePayment = async (e) => {
//     e.preventDefault();
//     setSaving(true);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error"
//         );
//         return;
//       }
//       const payload = new FormData();
//       payload.append("upi_id", formData.upi_id);
//       payload.append("account_holder_name", formData.account_holder_name);
//       payload.append("account_number", formData.account_number);
//       payload.append("ifsc_code", formData.ifsc_code);
//       payload.append("bank_name", formData.bank_name);
//       payload.append("branch_name", formData.branch_name);
//       payload.append("status", formData.status);
//       if (formData.qr_code) {
//         payload.append("qr_code", formData.qr_code);
//       }
//       const response = await fetch(`${API_URL}/manual-payment-create`, {
//         method: "POST",
//         headers: { Authorization: `Bearer ${token}` },
//         body: payload,
//       });
//       const result = await response.json();
//       if (!response.ok || result.success !== "1") {
//         showCustomMessageModal(
//           "Error",
//           result.message || "Failed to create manual payment details.",
//           "error"
//         );
//         return;
//       }
//       setShowAddModal(false);
//       resetAddForm();
//       await fetchPayments();
//       Swal.fire({
//         title: "Success",
//         text: result.message || "Manual payment details created successfully!",
//         icon: "success",
//         timer: 1800,
//         showConfirmButton: false,
//       });
//     } catch (err) {
//       console.error("Create Manual Payment Error:", err);
//       showCustomMessageModal(
//         "Error",
//         err.message || "Something went wrong!",
//         "error"
//       );
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleEditPayment = (payment) => {
//     setSelectedPayment(payment);
//     setEditFormData({
//       id: payment.id,
//       upi_id: payment.upi_id || "",
//       account_holder_name: payment.account_holder_name || "",
//       account_number: payment.account_number || "",
//       ifsc_code: payment.ifsc_code || "",
//       bank_name: payment.bank_name || "",
//       branch_name: payment.branch_name || "",
//       status: payment.status || "active",
//       qr_code: null,
//     });
//     setShowEditModal(true);
//   };

//   const handleUpdatePayment = async (e) => {
//     e.preventDefault();
//     setSaving(true);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error"
//         );
//         return;
//       }
//       const payload = new FormData();
//       payload.append("id", editFormData.id);
//       payload.append("upi_id", editFormData.upi_id);
//       payload.append("account_holder_name", editFormData.account_holder_name);
//       payload.append("account_number", editFormData.account_number);
//       payload.append("ifsc_code", editFormData.ifsc_code);
//       payload.append("bank_name", editFormData.bank_name);
//       payload.append("branch_name", editFormData.branch_name);
//       payload.append("status", editFormData.status);
//       if (editFormData.qr_code) {
//         payload.append("qr_code", editFormData.qr_code);
//       }
//       const response = await fetch(`${API_URL}/manual-payment-update`, {
//         method: "POST",
//         headers: { Authorization: `Bearer ${token}` },
//         body: payload,
//       });
//       const result = await response.json();
//       if (!response.ok || result.success !== "1") {
//         showCustomMessageModal(
//           "Error",
//           result.message || "Failed to update manual payment details.",
//           "error"
//         );
//         return;
//       }
//       setShowEditModal(false);
//       await fetchPayments();
//       Swal.fire({
//         title: "Success",
//         text: result.message || "Manual payment details updated successfully!",
//         icon: "success",
//         timer: 1800,
//         showConfirmButton: false,
//       });
//     } catch (err) {
//       console.error("Update Manual Payment Error:", err);
//       showCustomMessageModal(
//         "Error",
//         err.message || "Something went wrong!",
//         "error"
//       );
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleDeletePayment = (paymentId) => {
//     showCustomMessageModal(
//       "Confirm Deletion",
//       "Are you sure you want to delete this manual payment details? This action cannot be undone.",
//       "warning",
//       async () => {
//         try {
//           setLoading(true);
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal(
//               "Authentication Error",
//               "Authentication token not found. Please log in.",
//               "error"
//             );
//             return;
//           }
//           const response = await fetch(`${API_URL}/manual-payment-delete`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ id: paymentId }),
//           });
//           const result = await response.json();
//           if (!response.ok || result.success !== "1") {
//             showCustomMessageModal(
//               "Error",
//               result.message || "Failed to delete manual payment details.",
//               "error"
//             );
//             return;
//           }
//           await fetchPayments();
//           Swal.fire({
//             title: "Deleted",
//             text: result.message || "Manual payment details deleted successfully!",
//             icon: "success",
//             timer: 1800,
//             showConfirmButton: false,
//           });
//         } catch (err) {
//           console.error("Delete Manual Payment Error:", err);
//           showCustomMessageModal(
//             "Error",
//             err.message || "Something went wrong!",
//             "error"
//           );
//         } finally {
//           setLoading(false);
//         }
//       }
//     );
//   };

//   const handleStatusUpdate = async (paymentId, currentStatus) => {
//     const newStatus = currentStatus === "active" ? "inactive" : "active";
//     showCustomMessageModal(
//       "Confirm Status Change",
//       `Do you want to change the status to ${newStatus}?`,
//       "warning",
//       async () => {
//         try {
//           setLoading(true);
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal(
//               "Authentication Error",
//               "Authentication token not found. Please log in.",
//               "error"
//             );
//             return;
//           }
//           const payment = payments.find((item) => item.id === paymentId);
//           if (!payment) {
//             showCustomMessageModal(
//               "Error",
//               "Payment details not found.",
//               "error"
//             );
//             return;
//           }
//           const payload = new FormData();
//           payload.append("id", payment.id);
//           payload.append("upi_id", payment.upi_id || "");
//           payload.append("account_holder_name", payment.account_holder_name || "");
//           payload.append("account_number", payment.account_number || "");
//           payload.append("ifsc_code", payment.ifsc_code || "");
//           payload.append("bank_name", payment.bank_name || "");
//           payload.append("branch_name", payment.branch_name || "");
//           payload.append("status", newStatus);
//           const response = await fetch(`${API_URL}/manual-payment-update`, {
//             method: "POST",
//             headers: { Authorization: `Bearer ${token}` },
//             body: payload,
//           });
//           const result = await response.json();
//           if (!response.ok || result.success !== "1") {
//             showCustomMessageModal(
//               "Error",
//               result.message || "Failed to update status.",
//               "error"
//             );
//             return;
//           }
//           await fetchPayments();
//           Swal.fire({
//             title: "Success",
//             text: "Status updated successfully!",
//             icon: "success",
//             timer: 1500,
//             showConfirmButton: false,
//           });
//         } catch (err) {
//           console.error("Status Update Error:", err);
//           showCustomMessageModal(
//             "Error",
//             err.message || "Something went wrong!",
//             "error"
//           );
//         } finally {
//           setLoading(false);
//         }
//       }
//     );
//   };

//   const handleViewPayment = (payment) => {
//     setSelectedPayment(payment);
//     setShowViewModal(true);
//   };

//   const handleCloseEditModal = () => {
//     setShowEditModal(false);
//     setSelectedPayment(null);
//     setEditFormData({
//       id: "",
//       upi_id: "",
//       account_holder_name: "",
//       account_number: "",
//       ifsc_code: "",
//       bank_name: "",
//       branch_name: "",
//       status: "active",
//       qr_code: null,
//     });
//   };

//   const getQrUrl = (fileName) => {
//     if (!fileName) return "";
//     return `${imageAPIURL}/manual-payment/${fileName}`;
//   };

//   if (loading) {
//     return (
//       <div
//         className="d-flex justify-content-center align-items-center"
//         style={{ minHeight: "80vh" }}
//       >
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
//           {/* 🎯 HEADER CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               padding: "20px 24px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div
//               style={{
//                 width: "52px",
//                 height: "52px",
//                 borderRadius: "14px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "24px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                 flexShrink: 0,
//               }}
//             >
//               💳
//             </div>
//             <div style={{ flex: 1, minWidth: "200px" }}>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "24px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 All Manual Payment Details
//               </h1>
//               <p
//                 style={{
//                   margin: "2px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 Manage all manual payment details here
//               </p>
//             </div>

//             <button
//               onClick={() => {
//                 resetAddForm();
//                 setShowAddModal(true);
//               }}
//               style={{
//                 padding: "12px 20px",
//                 borderRadius: "12px",
//                 border: "none",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 color: "#ffffff",
//                 fontSize: "14px",
//                 fontWeight: "700",
//                 cursor: "pointer",
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 boxShadow: "0 8px 24px rgba(30, 87, 153, 0.3)",
//               }}
//             >
//               <FaPlus /> Add Payment
//             </button>
//           </div>

//           {/* 🎯 MAIN CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 height: "5px",
//                 background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div style={{ padding: "24px" }}>
//               <div className="table-responsive">
//                 <Table bordered hover>
//                   <thead
//                     style={{
//                       background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                       color: "#ffffff",
//                     }}
//                   >
//                     <tr>
//                       <th>#</th>
//                       <th>UPI ID</th>
//                       <th>QR Code</th>
//                       <th>Account Holder</th>
//                       <th>Bank</th>
//                       <th>Account Number</th>
//                       <th>IFSC</th>
//                       <th>Status</th>
//                       <th>Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {payments.length > 0 ? (
//                       payments.map((payment, index) => (
//                         <tr key={payment.id}>
//                           <td>{index + 1}</td>
//                           <td>{payment.upi_id || "-"}</td>
//                           <td>
//                             {payment.qr_code ? (
//                               <img
//                                 src={getQrUrl(payment.qr_code)}
//                                 alt="Payment QR"
//                                 style={{
//                                   width: "70px",
//                                   height: "70px",
//                                   objectFit: "contain",
//                                   borderRadius: "6px",
//                                   border: "1px solid #ddd",
//                                   padding: "3px",
//                                   cursor: "pointer",
//                                 }}
//                                 onClick={() => handleViewPayment(payment)}
//                                 onError={(e) => {
//                                   e.target.onerror = null;
//                                   e.target.style.display = "none";
//                                 }}
//                               />
//                             ) : (
//                               <span className="text-muted">No QR</span>
//                             )}
//                           </td>
//                           <td>{payment.account_holder_name || "-"}</td>
//                           <td>
//                             <div>{payment.bank_name || "-"}</div>
//                             {payment.branch_name && (
//                               <small className="text-muted">
//                                 {payment.branch_name}
//                               </small>
//                             )}
//                           </td>
//                           <td>{payment.account_number || "-"}</td>
//                           <td>{payment.ifsc_code || "-"}</td>
//                           <td>
//                             <span
//                               className={`badge ${
//                                 payment.status === "active"
//                                   ? "bg-success"
//                                   : "bg-danger"
//                               }`}
//                             >
//                               {payment.status}
//                             </span>
//                           </td>
//                           <td>
//                             <div className="dropdown">
//                               <button
//                                 className="btn light btn-action dropdown-toggle"
//                                 type="button"
//                                 id={`dropdownMenuButton-${payment.id}`}
//                                 data-bs-toggle="dropdown"
//                                 aria-expanded="false"
//                               >
//                                 <BsThreeDots size={20} />
//                               </button>
//                               <ul
//                                 className="dropdown-menu"
//                                 aria-labelledby={`dropdownMenuButton-${payment.id}`}
//                               >
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn view_btn btn-sm me-1"
//                                     onClick={() => handleViewPayment(payment)}
//                                   >
//                                     <FaEye /> View
//                                   </button>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn edit_btn btn-sm me-1"
//                                     onClick={() => handleEditPayment(payment)}
//                                   >
//                                     <FaEdit /> Edit
//                                   </button>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <button
//                                     className={`btn btn-sm ${
//                                       payment.status === "active"
//                                         ? "btn-danger"
//                                         : "btn-success"
//                                     }`}
//                                     onClick={() =>
//                                       handleStatusUpdate(
//                                         payment.id,
//                                         payment.status
//                                       )
//                                     }
//                                   >
//                                     {payment.status === "active" ? (
//                                       <MdAirplanemodeInactive />
//                                     ) : (
//                                       <MdAirplanemodeActive />
//                                     )}{" "}
//                                     {payment.status === "active"
//                                       ? "Deactivate"
//                                       : "Activate"}
//                                   </button>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn delete_btn btn-sm"
//                                     onClick={() =>
//                                       handleDeletePayment(payment.id)
//                                     }
//                                   >
//                                     <RiDeleteBin3Fill /> Delete
//                                   </button>
//                                 </li>
//                               </ul>
//                             </div>
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="9" className="text-center py-4">
//                           No manual payment details found.
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </Table>
//               </div>
//             </div>
//           </div>

//           {/* Footer Copyright */}
//           <p
//             style={{
//               textAlign: "center",
//               color: "#94a3b8",
//               fontSize: "12.5px",
//               marginTop: "24px",
//               fontWeight: "500",
//             }}
//           >
//             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
//             Rights Reserved.
//           </p>
//         </div>
//       </div>

//       {/* 🎯 ADD MODAL */}
//       <Modal
//         show={showAddModal}
//         onHide={() => !saving && setShowAddModal(false)}
//         centered
//         size="lg"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title style={{ color: "#1e3a5f", fontWeight: "800" }}>
//             Add Manual Payment Details
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleCreatePayment}>
//             <div className="row">
//               <div className="col-md-6">
//                 <Form.Group className="mb-3">
//                   <Form.Label>UPI ID</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="upi_id"
//                     placeholder="example@upi"
//                     value={formData.upi_id}
//                     onChange={handleFormChange}
//                   />
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3">
//                   <Form.Label>Account Holder Name</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="account_holder_name"
//                     placeholder="Enter account holder name"
//                     value={formData.account_holder_name}
//                     onChange={handleFormChange}
//                   />
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3">
//                   <Form.Label>Account Number</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="account_number"
//                     placeholder="Enter account number"
//                     value={formData.account_number}
//                     onChange={handleFormChange}
//                   />
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3">
//                   <Form.Label>IFSC Code</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="ifsc_code"
//                     placeholder="Enter IFSC code"
//                     value={formData.ifsc_code}
//                     onChange={handleFormChange}
//                   />
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3">
//                   <Form.Label>Bank Name</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="bank_name"
//                     placeholder="Enter bank name"
//                     value={formData.bank_name}
//                     onChange={handleFormChange}
//                   />
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3">
//                   <Form.Label>Branch Name</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="branch_name"
//                     placeholder="Enter branch name"
//                     value={formData.branch_name}
//                     onChange={handleFormChange}
//                   />
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3">
//                   <Form.Label>Status</Form.Label>
//                   <Form.Select
//                     name="status"
//                     value={formData.status}
//                     onChange={handleFormChange}
//                   >
//                     <option value="active">Active</option>
//                     <option value="inactive">Inactive</option>
//                   </Form.Select>
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3">
//                   <Form.Label>QR Code</Form.Label>
//                   <Form.Control
//                     type="file"
//                     name="qr_code"
//                     accept="image/png,image/jpeg,image/jpg"
//                     onChange={handleFormChange}
//                   />
//                   <small className="text-muted">JPG, JPEG or PNG only</small>
//                 </Form.Group>
//               </div>
//             </div>
//             <Button
//               type="submit"
//               variant="primary"
//               className="w-100"
//               disabled={saving}
//             >
//               {saving ? "Saving..." : "Save Payment Details"}
//             </Button>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* 🎯 EDIT MODAL */}
//       <Modal
//         show={showEditModal}
//         onHide={() => !saving && handleCloseEditModal()}
//         centered
//         size="lg"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title style={{ color: "#1e3a5f", fontWeight: "800" }}>
//             Edit Manual Payment Details
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleUpdatePayment}>
//             <div className="row">
//               <div className="col-md-6">
//                 <Form.Group className="mb-3">
//                   <Form.Label>UPI ID</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="upi_id"
//                     value={editFormData.upi_id}
//                     onChange={handleEditFormChange}
//                   />
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3">
//                   <Form.Label>Account Holder Name</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="account_holder_name"
//                     value={editFormData.account_holder_name}
//                     onChange={handleEditFormChange}
//                   />
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3">
//                   <Form.Label>Account Number</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="account_number"
//                     value={editFormData.account_number}
//                     onChange={handleEditFormChange}
//                   />
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3">
//                   <Form.Label>IFSC Code</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="ifsc_code"
//                     value={editFormData.ifsc_code}
//                     onChange={handleEditFormChange}
//                   />
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3">
//                   <Form.Label>Bank Name</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="bank_name"
//                     value={editFormData.bank_name}
//                     onChange={handleEditFormChange}
//                   />
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3">
//                   <Form.Label>Branch Name</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="branch_name"
//                     value={editFormData.branch_name}
//                     onChange={handleEditFormChange}
//                   />
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3">
//                   <Form.Label>Status</Form.Label>
//                   <Form.Select
//                     name="status"
//                     value={editFormData.status}
//                     onChange={handleEditFormChange}
//                   >
//                     <option value="active">Active</option>
//                     <option value="inactive">Inactive</option>
//                   </Form.Select>
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3">
//                   <Form.Label>Replace QR Code</Form.Label>
//                   <Form.Control
//                     type="file"
//                     name="qr_code"
//                     accept="image/png,image/jpeg,image/jpg"
//                     onChange={handleEditFormChange}
//                   />
//                 </Form.Group>
//               </div>
//               {selectedPayment && selectedPayment.qr_code && (
//                 <div className="col-md-12 mb-3">
//                   <div className="border rounded p-3">
//                     <small className="text-muted d-block mb-2">
//                       Current QR Code
//                     </small>
//                     <img
//                       src={getQrUrl(selectedPayment.qr_code)}
//                       alt="Current QR"
//                       style={{
//                         width: "150px",
//                         height: "150px",
//                         objectFit: "contain",
//                       }}
//                     />
//                   </div>
//                 </div>
//               )}
//             </div>
//             <Button
//               type="submit"
//               variant="primary"
//               className="w-100"
//               disabled={saving}
//             >
//               {saving ? "Updating..." : "Update Payment Details"}
//             </Button>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* 🎯 VIEW MODAL */}
//       <Modal
//         show={showViewModal}
//         onHide={() => setShowViewModal(false)}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title style={{ color: "#1e3a5f", fontWeight: "800" }}>
//             Payment Details
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {selectedPayment && (
//             <div>
//               {selectedPayment.qr_code && (
//                 <div className="text-center mb-4">
//                   <img
//                     src={getQrUrl(selectedPayment.qr_code)}
//                     alt="Payment QR"
//                     style={{
//                       width: "220px",
//                       height: "220px",
//                       objectFit: "contain",
//                       border: "1px solid #ddd",
//                       borderRadius: "10px",
//                       padding: "8px",
//                     }}
//                   />
//                 </div>
//               )}
//               <div className="mb-2">
//                 <strong>UPI ID:</strong>{" "}
//                 <span className="ms-2">{selectedPayment.upi_id || "-"}</span>
//               </div>
//               <div className="mb-2">
//                 <strong>Account Holder:</strong>{" "}
//                 <span className="ms-2">
//                   {selectedPayment.account_holder_name || "-"}
//                 </span>
//               </div>
//               <div className="mb-2">
//                 <strong>Account Number:</strong>{" "}
//                 <span className="ms-2">
//                   {selectedPayment.account_number || "-"}
//                 </span>
//               </div>
//               <div className="mb-2">
//                 <strong>IFSC:</strong>{" "}
//                 <span className="ms-2">{selectedPayment.ifsc_code || "-"}</span>
//               </div>
//               <div className="mb-2">
//                 <strong>Bank:</strong>{" "}
//                 <span className="ms-2">{selectedPayment.bank_name || "-"}</span>
//               </div>
//               <div className="mb-2">
//                 <strong>Branch:</strong>{" "}
//                 <span className="ms-2">
//                   {selectedPayment.branch_name || "-"}
//                 </span>
//               </div>
//               <div className="mb-2">
//                 <strong>Status:</strong>{" "}
//                 <span
//                   className={`badge ms-2 ${
//                     selectedPayment.status === "active"
//                       ? "bg-success"
//                       : "bg-danger"
//                   }`}
//                 >
//                   {selectedPayment.status}
//                 </span>
//               </div>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button
//             variant="secondary"
//             onClick={() => setShowViewModal(false)}
//           >
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* 🎯 MESSAGE MODAL */}
//       {showMessageModal && (
//         <div
//           className="modal d-block"
//           tabIndex="-1"
//           style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div
//               className={`modal-content border-top border-4 ${
//                 messageModalContent.type === "success"
//                   ? "border-success"
//                   : messageModalContent.type === "error"
//                   ? "border-danger"
//                   : "border-warning"
//               }`}
//             >
//               <div className="modal-header d-flex justify-content-between align-items-center">
//                 <h5
//                   className={`modal-title ${
//                     messageModalContent.type === "success"
//                       ? "text-success"
//                       : messageModalContent.type === "error"
//                       ? "text-danger"
//                       : "text-warning"
//                   }`}
//                 >
//                   {messageModalContent.title}
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   aria-label="Close"
//                   onClick={closeCustomMessageModal}
//                 />
//               </div>
//               <div className="modal-body text-secondary">
//                 <p>{messageModalContent.text}</p>
//               </div>
//               <div className="modal-footer justify-content-center">
//                 {messageModalContent.confirmAction ? (
//                   <>
//                     <Button
//                       variant="secondary"
//                       onClick={closeCustomMessageModal}
//                     >
//                       Cancel
//                     </Button>
//                     <Button
//                       variant="primary"
//                       onClick={() => {
//                         const action = messageModalContent.confirmAction;
//                         closeCustomMessageModal();
//                         action();
//                       }}
//                     >
//                       Confirm
//                     </Button>
//                   </>
//                 ) : (
//                   <Button
//                     variant={
//                       messageModalContent.type === "success"
//                         ? "success"
//                         : messageModalContent.type === "error"
//                         ? "danger"
//                         : "primary"
//                     }
//                     onClick={closeCustomMessageModal}
//                   >
//                     OK
//                   </Button>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// export default ManualPaymentList;

import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import Swal from "sweetalert2";
import { FaPlus, FaEye, FaEdit } from "react-icons/fa";
import { RiDeleteBin3Fill } from "react-icons/ri";
import { BsThreeDots } from "react-icons/bs";
import {
  MdAirplanemodeInactive,
  MdAirplanemodeActive,
} from "react-icons/md";

const API_URL = process.env.REACT_APP_API_URL;
const imageAPIURL = process.env.REACT_APP_Image_URL;

function ManualPaymentList() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [saving, setSaving] = useState(false);

  const [formData, setFormData] = useState({
    upi_id: "",
    account_holder_name: "",
    account_number: "",
    ifsc_code: "",
    bank_name: "",
    branch_name: "",
    status: "active",
    qr_code: null,
  });

  const [editFormData, setEditFormData] = useState({
    id: "",
    upi_id: "",
    account_holder_name: "",
    account_number: "",
    ifsc_code: "",
    bank_name: "",
    branch_name: "",
    status: "active",
    qr_code: null,
  });

  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageModalContent, setMessageModalContent] = useState({
    title: "",
    text: "",
    type: "",
    confirmAction: null,
  });

  const getAuthToken = () => localStorage.getItem("token");

  const showCustomMessageModal = (title, text, type, confirmAction = null) => {
    setMessageModalContent({ title, text, type, confirmAction });
    setShowMessageModal(true);
  };

  const closeCustomMessageModal = () => {
    setShowMessageModal(false);
    setMessageModalContent({
      title: "",
      text: "",
      type: "",
      confirmAction: null,
    });
  };

  // ═══════════════════════════════════════════
  // 🔹 FETCH PAYMENTS
  // ═══════════════════════════════════════════
  const fetchPayments = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Authentication token not found. Please log in.",
          "error"
        );
        return;
      }
      const response = await fetch(`${API_URL}/manual-payment-list`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      if (!response.ok) {
        showCustomMessageModal(
          "Error",
          data.message || "Failed to fetch manual payment details.",
          "error"
        );
        return;
      }
      if (data.success === "1") {
        setPayments(data.data || []);
      } else {
        showCustomMessageModal(
          "Error",
          data.message || "Failed to fetch manual payment details.",
          "error"
        );
      }
    } catch (err) {
      console.error("Fetch Manual Payment Error:", err);
      setError(err.message);
      showCustomMessageModal(
        "Error",
        err.message || "Something went wrong while fetching payment details.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resetAddForm = () => {
    setFormData({
      upi_id: "",
      account_holder_name: "",
      account_number: "",
      ifsc_code: "",
      bank_name: "",
      branch_name: "",
      status: "active",
      qr_code: null,
    });
  };

  const handleFormChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "qr_code") {
      setFormData((prev) => ({
        ...prev,
        qr_code: files && files[0] ? files[0] : null,
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleEditFormChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "qr_code") {
      setEditFormData((prev) => ({
        ...prev,
        qr_code: files && files[0] ? files[0] : null,
      }));
    } else {
      setEditFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 CREATE PAYMENT
  // ═══════════════════════════════════════════
  const handleCreatePayment = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Authentication token not found. Please log in.",
          "error"
        );
        return;
      }
      const payload = new FormData();
      payload.append("upi_id", formData.upi_id);
      payload.append("account_holder_name", formData.account_holder_name);
      payload.append("account_number", formData.account_number);
      payload.append("ifsc_code", formData.ifsc_code);
      payload.append("bank_name", formData.bank_name);
      payload.append("branch_name", formData.branch_name);
      payload.append("status", formData.status);
      if (formData.qr_code) {
        payload.append("qr_code", formData.qr_code);
      }
      const response = await fetch(`${API_URL}/manual-payment-create`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: payload,
      });
      const result = await response.json();
      if (!response.ok || result.success !== "1") {
        showCustomMessageModal(
          "Error",
          result.message || "Failed to create manual payment details.",
          "error"
        );
        return;
      }
      setShowAddModal(false);
      resetAddForm();
      await fetchPayments();
      Swal.fire({
        title: "Success",
        text: result.message || "Manual payment details created successfully!",
        icon: "success",
        timer: 1800,
        showConfirmButton: false,
      });
    } catch (err) {
      console.error("Create Manual Payment Error:", err);
      showCustomMessageModal(
        "Error",
        err.message || "Something went wrong!",
        "error"
      );
    } finally {
      setSaving(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 EDIT PAYMENT
  // ═══════════════════════════════════════════
  const handleEditPayment = (payment) => {
    setSelectedPayment(payment);
    setEditFormData({
      id: payment.id,
      upi_id: payment.upi_id || "",
      account_holder_name: payment.account_holder_name || "",
      account_number: payment.account_number || "",
      ifsc_code: payment.ifsc_code || "",
      bank_name: payment.bank_name || "",
      branch_name: payment.branch_name || "",
      status: payment.status || "active",
      qr_code: null,
    });
    setShowEditModal(true);
  };

  const handleUpdatePayment = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Authentication token not found. Please log in.",
          "error"
        );
        return;
      }
      const payload = new FormData();
      payload.append("id", editFormData.id);
      payload.append("upi_id", editFormData.upi_id);
      payload.append("account_holder_name", editFormData.account_holder_name);
      payload.append("account_number", editFormData.account_number);
      payload.append("ifsc_code", editFormData.ifsc_code);
      payload.append("bank_name", editFormData.bank_name);
      payload.append("branch_name", editFormData.branch_name);
      payload.append("status", editFormData.status);
      if (editFormData.qr_code) {
        payload.append("qr_code", editFormData.qr_code);
      }
      const response = await fetch(`${API_URL}/manual-payment-update`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: payload,
      });
      const result = await response.json();
      if (!response.ok || result.success !== "1") {
        showCustomMessageModal(
          "Error",
          result.message || "Failed to update manual payment details.",
          "error"
        );
        return;
      }
      setShowEditModal(false);
      await fetchPayments();
      Swal.fire({
        title: "Success",
        text: result.message || "Manual payment details updated successfully!",
        icon: "success",
        timer: 1800,
        showConfirmButton: false,
      });
    } catch (err) {
      console.error("Update Manual Payment Error:", err);
      showCustomMessageModal(
        "Error",
        err.message || "Something went wrong!",
        "error"
      );
    } finally {
      setSaving(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 DELETE PAYMENT
  // ═══════════════════════════════════════════
  const handleDeletePayment = (paymentId) => {
    showCustomMessageModal(
      "Confirm Deletion",
      "Are you sure you want to delete this manual payment details? This action cannot be undone.",
      "warning",
      async () => {
        try {
          setLoading(true);
          const token = getAuthToken();
          if (!token) {
            showCustomMessageModal(
              "Authentication Error",
              "Authentication token not found. Please log in.",
              "error"
            );
            return;
          }
          const response = await fetch(`${API_URL}/manual-payment-delete`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ id: paymentId }),
          });
          const result = await response.json();
          if (!response.ok || result.success !== "1") {
            showCustomMessageModal(
              "Error",
              result.message || "Failed to delete manual payment details.",
              "error"
            );
            return;
          }
          await fetchPayments();
          Swal.fire({
            title: "Deleted",
            text:
              result.message || "Manual payment details deleted successfully!",
            icon: "success",
            timer: 1800,
            showConfirmButton: false,
          });
        } catch (err) {
          console.error("Delete Manual Payment Error:", err);
          showCustomMessageModal(
            "Error",
            err.message || "Something went wrong!",
            "error"
          );
        } finally {
          setLoading(false);
        }
      }
    );
  };

  // ═══════════════════════════════════════════
  // 🔹 STATUS UPDATE
  // ═══════════════════════════════════════════
  const handleStatusUpdate = (paymentId, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    showCustomMessageModal(
      "Confirm Status Change",
      `Do you want to change the status to ${newStatus}?`,
      "warning",
      async () => {
        try {
          setLoading(true);
          const token = getAuthToken();
          if (!token) {
            showCustomMessageModal(
              "Authentication Error",
              "Authentication token not found. Please log in.",
              "error"
            );
            return;
          }
          const payment = payments.find((item) => item.id === paymentId);
          if (!payment) {
            showCustomMessageModal(
              "Error",
              "Payment details not found.",
              "error"
            );
            return;
          }
          const payload = new FormData();
          payload.append("id", payment.id);
          payload.append("upi_id", payment.upi_id || "");
          payload.append(
            "account_holder_name",
            payment.account_holder_name || ""
          );
          payload.append("account_number", payment.account_number || "");
          payload.append("ifsc_code", payment.ifsc_code || "");
          payload.append("bank_name", payment.bank_name || "");
          payload.append("branch_name", payment.branch_name || "");
          payload.append("status", newStatus);
          const response = await fetch(`${API_URL}/manual-payment-update`, {
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            body: payload,
          });
          const result = await response.json();
          if (!response.ok || result.success !== "1") {
            showCustomMessageModal(
              "Error",
              result.message || "Failed to update status.",
              "error"
            );
            return;
          }
          await fetchPayments();
          Swal.fire({
            title: "Success",
            text: "Status updated successfully!",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
        } catch (err) {
          console.error("Status Update Error:", err);
          showCustomMessageModal(
            "Error",
            err.message || "Something went wrong!",
            "error"
          );
        } finally {
          setLoading(false);
        }
      }
    );
  };

  const handleViewPayment = (payment) => {
    setSelectedPayment(payment);
    setShowViewModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedPayment(null);
    setEditFormData({
      id: "",
      upi_id: "",
      account_holder_name: "",
      account_number: "",
      ifsc_code: "",
      bank_name: "",
      branch_name: "",
      status: "active",
      qr_code: null,
    });
  };

  const getQrUrl = (fileName) => {
    if (!fileName) return "";
    return `${imageAPIURL}/manual-payment/${fileName}`;
  };

  // ═══════════════════════════════════════════
  // 🔹 LOADING
  // ═══════════════════════════════════════════
  if (loading) {
    return (
      <div
        style={{
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "4px solid #e2e8f0",
            borderTop: "4px solid #1e5799",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <style>{`@keyframes spin { from {transform:rotate(0deg);} to {transform:rotate(360deg);} }`}</style>
      </div>
    );
  }

  // ═══════════════════════════════════════════
  // 🎨 UI RENDER
  // ═══════════════════════════════════════════
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        padding: "24px",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
      }}
    >
      <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
        <div
          style={{
            background: "#ffffff",
            borderRadius: "20px",
            boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
            border: "1.5px solid #e2e8f0",
            overflow: "hidden",
          }}
        >
          {/* Top Gradient */}
          <div
            style={{
              height: "5px",
              background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
            }}
          />

          {/* Header */}
          <div
            style={{
              padding: "24px 30px",
              background: "linear-gradient(135deg, #ffffff, #f8fafc)",
              borderBottom: "1.5px solid #e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "14px",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  fontSize: "22px",
                  boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                  flexShrink: 0,
                }}
              >
                💳
              </div>
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#1e3a5f",
                  }}
                >
                  All Manual Payment Details
                </h2>
                <p
                  style={{
                    margin: "2px 0 0",
                    fontSize: "12.5px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  Manage all manual payment details ({payments.length} total)
                </p>
              </div>
            </div>

            <button
              onClick={() => {
                resetAddForm();
                setShowAddModal(true);
              }}
              style={{
                padding: "10px 20px",
                borderRadius: "10px",
                border: "none",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                color: "#ffffff",
                fontSize: "13px",
                fontWeight: "700",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
              }}
            >
              <FaPlus /> Add Payment
            </button>
          </div>

          {/* Body */}
          <div style={{ padding: "24px 30px" }}>
            <div
              style={{
                overflowX: "auto",
                overflowY: "visible",
                borderRadius: "14px",
                border: "1.5px solid #e2e8f0",
              }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "13px",
                }}
              >
                <thead>
                  <tr
                    style={{
                      background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                    }}
                  >
                    {[
                      "#",
                      "UPI ID",
                      "QR Code",
                      "Account Holder",
                      "Bank",
                      "Account Number",
                      "IFSC",
                      "Status",
                      "Actions",
                    ].map((th, i) => (
                      <th
                        key={i}
                        style={{
                          padding: "14px 12px",
                          color: "#ffffff",
                          fontWeight: "700",
                          fontSize: "11.5px",
                          textAlign: "left",
                          letterSpacing: "0.5px",
                          textTransform: "uppercase",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {th}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {payments.length > 0 ? (
                    payments.map((payment, index) => (
                      <tr
                        key={payment.id}
                        style={{ borderBottom: "1px solid #f1f5f9" }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#f8fafc")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "transparent")
                        }
                      >
                        <td style={cellBlue}>{index + 1}</td>
                        <td style={cellDark}>{payment.upi_id || "-"}</td>
                        <td style={{ padding: "12px" }}>
                          {payment.qr_code ? (
                            <img
                              src={getQrUrl(payment.qr_code)}
                              alt="Payment QR"
                              style={{
                                width: "60px",
                                height: "60px",
                                objectFit: "contain",
                                borderRadius: "8px",
                                border: "1.5px solid #e2e8f0",
                                padding: "3px",
                                cursor: "pointer",
                                background: "#ffffff",
                              }}
                              onClick={() => handleViewPayment(payment)}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.style.display = "none";
                              }}
                            />
                          ) : (
                            <span
                              style={{
                                color: "#94a3b8",
                                fontSize: "12px",
                                fontWeight: "600",
                              }}
                            >
                              —
                            </span>
                          )}
                        </td>
                        <td style={cellDark}>
                          {payment.account_holder_name || "-"}
                        </td>
                        <td style={cellGray}>
                          <div>{payment.bank_name || "-"}</div>
                          {payment.branch_name && (
                            <small
                              style={{
                                color: "#94a3b8",
                                fontSize: "11.5px",
                              }}
                            >
                              {payment.branch_name}
                            </small>
                          )}
                        </td>
                        <td style={cellGray}>
                          {payment.account_number || "-"}
                        </td>
                        <td style={cellGray}>{payment.ifsc_code || "-"}</td>
                        <td style={{ padding: "12px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              padding: "4px 12px",
                              borderRadius: "20px",
                              fontSize: "11.5px",
                              fontWeight: "700",
                              background:
                                payment.status === "active"
                                  ? "#e7f9eb"
                                  : "#feeaeb",
                              color:
                                payment.status === "active"
                                  ? "#059669"
                                  : "#dc2626",
                              textTransform: "capitalize",
                            }}
                          >
                            {payment.status}
                          </span>
                        </td>
                        <td style={{ padding: "12px" }}>
                          <div className="dropdown">
                            <button
                              className="btn dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              data-bs-boundary="viewport"
                              data-bs-popper-config='{"strategy":"fixed"}'
                              aria-expanded="false"
                              style={{
                                background: "#f8fafc",
                                border: "1.5px solid #e2e8f0",
                                borderRadius: "8px",
                                width: "36px",
                                height: "36px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#1e5799",
                                padding: 0,
                              }}
                            >
                              <BsThreeDots size={18} />
                            </button>
                            <ul
                              className="dropdown-menu"
                              style={{
                                zIndex: 9999,
                                borderRadius: "14px",
                                border: "none",
                                padding: "8px",
                                boxShadow:
                                  "0 12px 40px rgba(30, 87, 153, 0.18), 0 4px 12px rgba(0,0,0,0.06)",
                                minWidth: "230px",
                                marginTop: "8px",
                                background: "#ffffff",
                              }}
                            >
                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() => handleViewPayment(payment)}
                                  style={dropdownItem}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#e8f1fb";
                                    e.currentTarget.style.transform =
                                      "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <span style={iconBadge("#e8f1fb", "#1e5799")}>
                                    <FaEye size={13} />
                                  </span>
                                  View Details
                                </button>
                              </li>

                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() => handleEditPayment(payment)}
                                  style={dropdownItem}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#e7f9eb";
                                    e.currentTarget.style.transform =
                                      "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <span style={iconBadge("#e7f9eb", "#059669")}>
                                    <FaEdit size={13} />
                                  </span>
                                  Edit Details
                                </button>
                              </li>

                              <li>
                                <hr
                                  style={{
                                    margin: "6px 8px",
                                    border: "none",
                                    borderTop: "1.5px dashed #e2e8f0",
                                  }}
                                />
                              </li>

                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() =>
                                    handleStatusUpdate(
                                      payment.id,
                                      payment.status
                                    )
                                  }
                                  style={{
                                    ...dropdownItem,
                                    color:
                                      payment.status === "active"
                                        ? "#dc2626"
                                        : "#059669",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background =
                                      payment.status === "active"
                                        ? "#feeaeb"
                                        : "#e7f9eb";
                                    e.currentTarget.style.transform =
                                      "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <span
                                    style={iconBadge(
                                      payment.status === "active"
                                        ? "#feeaeb"
                                        : "#e7f9eb",
                                      payment.status === "active"
                                        ? "#dc2626"
                                        : "#059669"
                                    )}
                                  >
                                    {payment.status === "active" ? (
                                      <MdAirplanemodeInactive size={13} />
                                    ) : (
                                      <MdAirplanemodeActive size={13} />
                                    )}
                                  </span>
                                  {payment.status === "active"
                                    ? "Deactivate"
                                    : "Activate"}
                                </button>
                              </li>

                              <li>
                                <hr
                                  style={{
                                    margin: "6px 8px",
                                    border: "none",
                                    borderTop: "1.5px dashed #e2e8f0",
                                  }}
                                />
                              </li>

                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() => handleDeletePayment(payment.id)}
                                  style={{ ...dropdownItem, color: "#dc2626" }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#feeaeb";
                                    e.currentTarget.style.transform =
                                      "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <span style={iconBadge("#feeaeb", "#dc2626")}>
                                    <RiDeleteBin3Fill size={13} />
                                  </span>
                                  Delete
                                </button>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="9"
                        style={{
                          padding: "50px",
                          textAlign: "center",
                          color: "#94a3b8",
                          fontWeight: "600",
                        }}
                      >
                        📭 No manual payment details found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 ADD MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={showAddModal}
        onHide={() => !saving && setShowAddModal(false)}
        centered
        size="lg"
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            ➕ Add Manual Payment Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ padding: "24px", maxHeight: "70vh", overflowY: "auto" }}
        >
          <Form onSubmit={handleCreatePayment}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>UPI ID</Form.Label>
                  <Form.Control
                    type="text"
                    name="upi_id"
                    placeholder="example@upi"
                    value={formData.upi_id}
                    onChange={handleFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>
                    Account Holder Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="account_holder_name"
                    placeholder="Enter account holder name"
                    value={formData.account_holder_name}
                    onChange={handleFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Account Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="account_number"
                    placeholder="Enter account number"
                    value={formData.account_number}
                    onChange={handleFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>IFSC Code</Form.Label>
                  <Form.Control
                    type="text"
                    name="ifsc_code"
                    placeholder="Enter IFSC code"
                    value={formData.ifsc_code}
                    onChange={handleFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Bank Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="bank_name"
                    placeholder="Enter bank name"
                    value={formData.bank_name}
                    onChange={handleFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Branch Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="branch_name"
                    placeholder="Enter branch name"
                    value={formData.branch_name}
                    onChange={handleFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Status</Form.Label>
                  <Form.Select
                    name="status"
                    value={formData.status}
                    onChange={handleFormChange}
                    style={inputStyle}
                  >
                    <option value="active">✅ Active</option>
                    <option value="inactive">⛔ Inactive</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>QR Code</Form.Label>
                  <Form.Control
                    type="file"
                    name="qr_code"
                    accept="image/png,image/jpeg,image/jpg"
                    onChange={handleFormChange}
                    style={inputStyle}
                  />
                  <Form.Text
                    style={{
                      color: "#64748b",
                      fontSize: "11.5px",
                      fontWeight: "500",
                    }}
                  >
                    JPG, JPEG or PNG only
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
            <Button
              type="submit"
              variant="primary"
              className="w-100"
              disabled={saving}
              style={{
                borderRadius: "10px",
                fontWeight: "700",
                padding: "12px",
                background: saving
                  ? "#cbd5e1"
                  : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                border: "none",
                boxShadow: saving
                  ? "none"
                  : "0 6px 18px rgba(30, 87, 153, 0.3)",
              }}
            >
              {saving ? "Saving..." : "Save Payment Details"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 EDIT MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={showEditModal}
        onHide={() => !saving && handleCloseEditModal()}
        centered
        size="lg"
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            ✏️ Edit Manual Payment Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ padding: "24px", maxHeight: "70vh", overflowY: "auto" }}
        >
          <Form onSubmit={handleUpdatePayment}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>UPI ID</Form.Label>
                  <Form.Control
                    type="text"
                    name="upi_id"
                    value={editFormData.upi_id}
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>
                    Account Holder Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="account_holder_name"
                    value={editFormData.account_holder_name}
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Account Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="account_number"
                    value={editFormData.account_number}
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>IFSC Code</Form.Label>
                  <Form.Control
                    type="text"
                    name="ifsc_code"
                    value={editFormData.ifsc_code}
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Bank Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="bank_name"
                    value={editFormData.bank_name}
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Branch Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="branch_name"
                    value={editFormData.branch_name}
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Status</Form.Label>
                  <Form.Select
                    name="status"
                    value={editFormData.status}
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  >
                    <option value="active">✅ Active</option>
                    <option value="inactive">⛔ Inactive</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Replace QR Code</Form.Label>
                  <Form.Control
                    type="file"
                    name="qr_code"
                    accept="image/png,image/jpeg,image/jpg"
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              {selectedPayment && selectedPayment.qr_code && (
                <Col md={12} className="mb-3">
                  <div
                    style={{
                      border: "1.5px dashed #e2e8f0",
                      borderRadius: "12px",
                      padding: "16px",
                      background: "#f8fafc",
                      textAlign: "center",
                    }}
                  >
                    <small
                      style={{
                        color: "#64748b",
                        display: "block",
                        marginBottom: "10px",
                        fontWeight: "600",
                        fontSize: "11.5px",
                      }}
                    >
                      Current QR Code
                    </small>
                    <img
                      src={getQrUrl(selectedPayment.qr_code)}
                      alt="Current QR"
                      style={{
                        width: "150px",
                        height: "150px",
                        objectFit: "contain",
                        background: "#ffffff",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        padding: "6px",
                      }}
                    />
                  </div>
                </Col>
              )}
            </Row>
            <Button
              type="submit"
              variant="primary"
              className="w-100"
              disabled={saving}
              style={{
                borderRadius: "10px",
                fontWeight: "700",
                padding: "12px",
                background: saving
                  ? "#cbd5e1"
                  : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                border: "none",
                boxShadow: saving
                  ? "none"
                  : "0 6px 18px rgba(30, 87, 153, 0.3)",
              }}
            >
              {saving ? "Updating..." : "Update Payment Details"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 VIEW MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        centered
        size="lg"
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            💳 Payment Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ padding: "24px", maxHeight: "70vh", overflowY: "auto" }}
        >
          {selectedPayment && (
            <>
              {selectedPayment.qr_code && (
                <div
                  style={{
                    textAlign: "center",
                    marginBottom: "24px",
                    padding: "16px",
                    background: "#f8fafc",
                    borderRadius: "12px",
                    border: "1.5px dashed #e2e8f0",
                  }}
                >
                  <img
                    src={getQrUrl(selectedPayment.qr_code)}
                    alt="Payment QR"
                    style={{
                      width: "220px",
                      height: "220px",
                      objectFit: "contain",
                      background: "#ffffff",
                      borderRadius: "10px",
                      padding: "8px",
                      border: "1.5px solid #e2e8f0",
                    }}
                  />
                </div>
              )}

              <Row>
                <Col md={6} className="mb-3">
                  <strong style={labelColor}>UPI ID:</strong>
                  <p style={textDark}>{selectedPayment.upi_id || "-"}</p>
                </Col>
                <Col md={6} className="mb-3">
                  <strong style={labelColor}>Account Holder:</strong>
                  <p style={textDark}>
                    {selectedPayment.account_holder_name || "-"}
                  </p>
                </Col>
                <Col md={6} className="mb-3">
                  <strong style={labelColor}>Account Number:</strong>
                  <p style={textDark}>
                    {selectedPayment.account_number || "-"}
                  </p>
                </Col>
                <Col md={6} className="mb-3">
                  <strong style={labelColor}>IFSC Code:</strong>
                  <p style={textDark}>{selectedPayment.ifsc_code || "-"}</p>
                </Col>
                <Col md={6} className="mb-3">
                  <strong style={labelColor}>Bank Name:</strong>
                  <p style={textDark}>{selectedPayment.bank_name || "-"}</p>
                </Col>
                <Col md={6} className="mb-3">
                  <strong style={labelColor}>Branch Name:</strong>
                  <p style={textDark}>{selectedPayment.branch_name || "-"}</p>
                </Col>
                <Col md={12} className="mb-3">
                  <strong style={labelColor}>Status:</strong>
                  <p style={{ margin: "4px 0" }}>
                    <span
                      style={{
                        display: "inline-block",
                        padding: "4px 12px",
                        borderRadius: "20px",
                        fontSize: "11.5px",
                        fontWeight: "700",
                        background:
                          selectedPayment.status === "active"
                            ? "#e7f9eb"
                            : "#feeaeb",
                        color:
                          selectedPayment.status === "active"
                            ? "#059669"
                            : "#dc2626",
                        textTransform: "capitalize",
                      }}
                    >
                      {selectedPayment.status}
                    </span>
                  </p>
                </Col>
              </Row>
            </>
          )}
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "1.5px solid #e2e8f0" }}>
          <Button
            variant="secondary"
            onClick={() => setShowViewModal(false)}
            style={{
              borderRadius: "10px",
              fontWeight: "700",
              padding: "8px 24px",
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 MESSAGE MODAL — Solid #1e5799 */}
      {/* ═══════════════════════════════════════════ */}
      {showMessageModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 99999,
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content"
              style={{
                borderRadius: "16px",
                border: "none",
                overflow: "hidden",
                boxShadow: "0 20px 60px rgba(30, 87, 153, 0.25)",
              }}
            >
              <div
                style={{
                  background: "#1e5799",
                  color: "#ffffff",
                  padding: "16px 24px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h5 style={{ margin: 0, fontWeight: "800", fontSize: "16px" }}>
                  {messageModalContent.title}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  aria-label="Close"
                  onClick={closeCustomMessageModal}
                ></button>
              </div>
              <div
                className="modal-body"
                style={{ padding: "24px", fontSize: "14px", color: "#334155" }}
              >
                {messageModalContent.text}
              </div>
              <div
                className="modal-footer"
                style={{
                  borderTop: "1.5px solid #e2e8f0",
                  padding: "16px 24px",
                  gap: "10px",
                }}
              >
                {messageModalContent.confirmAction ? (
                  <>
                    <button
                      type="button"
                      onClick={closeCustomMessageModal}
                      style={{
                        padding: "10px 22px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color: "#64748b",
                        fontSize: "13px",
                        fontWeight: "700",
                        cursor: "pointer",
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        const action = messageModalContent.confirmAction;
                        closeCustomMessageModal();
                        action();
                      }}
                      style={{
                        padding: "10px 22px",
                        borderRadius: "10px",
                        border: "none",
                        background: "#1e5799",
                        color: "#ffffff",
                        fontSize: "13px",
                        fontWeight: "700",
                        cursor: "pointer",
                        boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
                      }}
                    >
                      Confirm
                    </button>
                  </>
                ) : (
                  <button
                    type="button"
                    onClick={closeCustomMessageModal}
                    style={{
                      padding: "10px 22px",
                      borderRadius: "10px",
                      border: "none",
                      background: "#1e5799",
                      color: "#ffffff",
                      fontSize: "13px",
                      fontWeight: "700",
                      cursor: "pointer",
                      boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
                    }}
                  >
                    OK
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════
// 🎨 SHARED STYLES
// ═══════════════════════════════════════════
const labelStyle = {
  display: "block",
  fontSize: "12.5px",
  fontWeight: "700",
  color: "#1e3a5f",
  marginBottom: "6px",
};

const inputStyle = {
  width: "100%",
  padding: "10px 14px",
  borderRadius: "10px",
  border: "1.5px solid #e2e8f0",
  fontSize: "13.5px",
  fontWeight: "500",
  color: "#1e3a5f",
  outline: "none",
  boxSizing: "border-box",
};

const labelColor = { color: "#1e5799" };
const textDark = { margin: "4px 0", color: "#334155" };

const cellBlue = { padding: "12px", fontWeight: "700", color: "#1e5799" };
const cellDark = { padding: "12px", fontWeight: "600", color: "#1e3a5f" };
const cellGray = { padding: "12px", color: "#64748b" };

const dropdownItem = {
  padding: "9px 12px",
  borderRadius: "10px",
  fontSize: "13px",
  fontWeight: "600",
  gap: "10px",
  transition: "all 0.18s ease",
  marginBottom: "2px",
  border: "none",
  background: "transparent",
  width: "100%",
  textAlign: "left",
  color: "#1e5799",
};

const iconBadge = (bg, color) => ({
  width: "28px",
  height: "28px",
  borderRadius: "8px",
  background: bg,
  color: color,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

export default ManualPaymentList;